import React from 'react';
import { useTranslation } from 'react-i18next';
import { Namespace } from 'i18next';
import { styled } from 'styles';
import { PlayShort } from 'icons';
import HeroBannerShort from 'Explore/HeroBanner/HeroBannerShort/HeroBannerShort';
import { PersonalisedTodayContent_dailyBoostShort as DailyBoost } from 'Home/PersonalisedToday/__generated__/PersonalisedTodayContent';
import SectionHeading from '../SectionHeading';
import { HomeScreenSection } from '../../PersonalisedToday/PersonalisedTodayScreen';
import { FeaturedContentWrapper } from './FeaturedContent';

const PlayShortIcon = styled(PlayShort).attrs(({ theme }) => ({
  primaryColor: theme.colors.border.primary,
  secondaryColor: theme.colors.brand.primary,
  tertiaryColor: theme.colors.background.input,
  height: 32,
  width: 32,
  'aria-hidden': true,
}))``;

type FeaturedDailyBoostProps = {
  assetToken: string | null | undefined;
  dailyBoost?: DailyBoost | null;
};

const FeaturedDailyBoost = ({
  assetToken,
  dailyBoost,
}: FeaturedDailyBoostProps) => {
  const { t: translate } = useTranslation<Namespace<'homepage'>>('homepage');

  return dailyBoost ? (
    <HomeScreenSection>
      <SectionHeading
        title={translate('managers_today.featured_banner.daily_boost.title')}
        iconComponent={<PlayShortIcon />}
      />

      <FeaturedContentWrapper>
        <HeroBannerShort
          tool={dailyBoost}
          assetToken={assetToken}
          source="today-manager-hero-banner"
        />
      </FeaturedContentWrapper>
    </HomeScreenSection>
  ) : null;
};

export default FeaturedDailyBoost;
